import React from 'react';
import { Typography } from '@mui/material';
import { TextField } from './TextField';
import { LongTextField } from './LongTextField';
import { SingleChoiceField } from './SingleChoiceField';
import { MultipleChoiceField } from './MultipleChoiceField';
import { DropdownField } from './DropdownField';
import { LikertField } from './LikertField';
import { DateField } from './DateField';
import { SignatureField } from './SignatureField';
import { DisplayTextField } from './DisplayTextField';
import type { FormFieldRendererProps } from './types';

/**
 * Main field renderer component that routes to the appropriate field component
 * based on the field type/kind
 */
export const FormFieldRenderer: React.FC<FormFieldRendererProps> = (props) => {
  const { field } = props;
  
  // Determine field type - check both 'type' and 'kind' properties
  const fieldType = 'type' in field ? field.type : 
                    'kind' in field ? field.kind : 
                    '';

  // Route to appropriate component based on field type
  switch (fieldType) {
    // Text fields
    case 'text':
    case 'email':
    case 'tel':
    case 'number':
    case 'short_text':
      return <TextField {...props} />;
    
    // Long text fields
    case 'textarea':
    case 'long_text':
      return <LongTextField {...props} />;
    
    // Single choice fields
    case 'radio':
    case 'single_choice':
      return <SingleChoiceField {...props} />;
    
    // Multiple choice fields
    case 'checkbox':
    case 'multiple_choice':
      return <MultipleChoiceField {...props} />;
    
    // Dropdown fields
    case 'select':
    case 'dropdown':
      return <DropdownField {...props} />;
    
    // Likert scale
    case 'likert':
      return <LikertField {...props} />;
    
    // Date field
    case 'date':
      return <DateField {...props} />;
    
    // Signature field
    case 'signature':
      return <SignatureField {...props} />;
    
    // Display text field
    case 'display_text':
      return <DisplayTextField {...props} />;
    
    // Unknown field type
    default:
      return (
        <Typography color="error" sx={{ mb: 2 }}>
          Unknown field type: {fieldType}
        </Typography>
      );
  }
};